import * as R from 'ramda';
export var parseCategorisations = function parseCategorisations(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === undefined ? {} : _ref$data;
  return R.pipe(R.propOr([], 'categorisations'), R.reduce(function (acc, cat) {
    var artefactUrn = R.propOr('', 'source', cat);
    var matchArtefact = artefactUrn.match(/=([\w@_.]+:[\w@_]+\([\d.]+\))$/);
    if (R.isNil(matchArtefact)) {
      return acc;
    }
    var categoryUrn = R.propOr('', 'target', cat);
    var matchCategory = categoryUrn.match(/=([\w@_.]+:[\w@_]+\([\d.]+\)).([\w@_.]+)$/);
    if (R.isNil(matchCategory)) {
      return acc;
    }
    var artefactId = matchArtefact[1];
    var schemeId = matchCategory[1],
      path = matchCategory[2];
    return R.over(R.lensProp(artefactId), R.ifElse(R.isNil, R.always([{
      schemeId: schemeId,
      path: path
    }]), R.append({
      schemeId: schemeId,
      path: path
    })))(acc);
  }, {}))(data);
};